export default __webpack_public_path__ + "static/media/expoai.f33677a4.png";